import { StatusType } from 'types/common';
import { IRequestsTableFiltersFormFields } from './types';

export const defaultValues: IRequestsTableFiltersFormFields = { status: 'Pending', search: '' };

export const statusOptions: StatusType[] = ['Pending', 'Declined', 'Revise'];
